import React from 'react';

import MasterCard from './images/mastercard.inline.svg';
import Nequi from './images/nequi.inline.svg';
import Visa from './images/visa.inline.svg';
import Codensa from './images/codensa.inline.svg';
import Alkosto from './images/alkosto.inline.svg';
import Olimpica from './images/olimpica.inline.svg';
import Pse from './images/pse.inline.svg';
import DaviPlata from './images/daviplata.inline.svg';
import AmericanExpress from './images/amex.inline.svg';
import Diners from './images/diners.inline.svg';
import Discover from './images/discover.inline.svg';
import GooglePay from './images/gpay.inline.svg';
import ApplePay from './images/apay.inline.svg';

import './franchises-carousel.scss';

const FranchisesCarousel = ({ isPayButton }) => {
  const franchises = isPayButton
    ? [MasterCard, Nequi, Visa, Codensa, Olimpica, Pse, DaviPlata, AmericanExpress, Diners, Discover]
    : [
        MasterCard,
        Nequi,
        Visa,
        Codensa,
        Alkosto,
        Olimpica,
        Pse,
        DaviPlata,
        AmericanExpress,
        Diners,
        Discover,
        GooglePay,
        ApplePay,
      ];
  return (
    <div className="franchises-carousel">
      <div className="ticker-wrapper">
        <div className="ticker-one">
          {franchises.map((Franchise, i) => (
            <div key={`franchise-${i + 1}`} className="ticker-item">
              <Franchise />
            </div>
          ))}
        </div>
        <div className="ticker-two">
          {franchises.map((Franchise, i) => (
            <div key={`franchise-${i + 1}`} className="ticker-item">
              <Franchise />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FranchisesCarousel;
